import React, { useEffect, useState } from "react";
import Layout from "../../common/layout";
import { useTranslation } from "react-i18next";
import ListTable from "../../../elements/list/list";
import { Container } from "../../common/layout/styels";
import ViewFiles from "../documents/ViewFiles";
import { useSelector } from "react-redux";
import { getData } from "../../../../backend/api";
import NationalityChart from "./chart";
const Nationalities = (props) => {
  const { t } = useTranslation();

  const user = useSelector((state)=> state.login)

  const [userCountNation, setUserCountNation] = useState([]);

  const [attributes] = useState([
    {
      type: "number",
      placeholder: "personalNumber",
      name: "personalNumber",
      tab: "generalInfo",
      validation: "",
      default: user?.data?.highestPersonnelNumber,
      label: "personalNumber",
      required: false,
      view: true,
      add: false,
      update: false,
    },
    {
      type: "text",
      placeholder: "--",
      name: "fullName",
      tab: "generalInfo",
      validation: "textonly",
      default: "",
      label: "fullName",
      required: false,
      view: true,
      add: false,
      update: false,
    },
    {
      type: "text",
      placeholder: "enterEmail",
      tab: "generalInfo",
      name: "email",
      validation: "email",
      default: "",
      label: "email",
      required: false,
      upload: true,
      view: true,
      tag: true,
      add: true,
      update: true,
    },
    {
      type: "select",
      placeholder: "select",
      name: "location",
      tab: "generalInfo",
      validation: "",
      showItem: "title",
      default: "",
      label: "location",
      required: false,
      filter: true,
      view: false,
      tag: false,
      add: false,
      update: false,
      apiType: "API",
      selectApi: "location/select",
    },
    {
      type: "select",
      placeholder: "select",
      name: "department",
      tab: "generalInfo",
      validation: "",
      showItem: "title",
      default: "",
      label: "department",
      required: true,
      view: true,
      tag: true,
      add: true,
      update: true,
      apiType: "API",
      selectApi: "department/select",
      filter: true
    },
    
    {
      type: "select",
      placeholder: "select",
      tab: "generalInfo",
      name: "place",
      validation: "",
      showItem: "title",
      default: "",
      label: "place",
      required: true,
      view: true,
      tag: true,
      add: true,
      update: true,
      apiType: "API",
      selectApi: "place/select",
      filter: false
    },
    {
      type: "select",
      apiType: "API",
      selectApi: "user/nationalities",
      placeholder: "select",
      name: "nationality",
      filter: false,
      tab: "personalData",
      validation: "",
      showItem: "locale",
      default: "",
      label: "nationality",
      required: false,
      view: true,
      tag: true,
      add: true,
      update: true,
    },
    {
      type: "expired",
      placeholder: "status",
      tab: "generalInfo",
      name: "contractEnd",
      validation: "",
      collection: "",
      showItem: "contractEnd",
      default: "",
      value: "Active",
      ifNull: "Active",
      label: "status",
      required: false,
      view: false,
      tag: false,
      add: false,
      update: false,
    },
    {
      type: "select",
      placeholder: "status",
      name: "status",
      tab: "socialInsurance",
      validation: "",
      default: "active",
      value: "active",
      label: "status",
      required: false,
      filterType: "select",
      view: false,
      tag: false,
      add: false,
      update: false,
      filter: true,
      apiType: "JSON",
      selectApi: [
        { id: "active", value: t("active") },
        { id: "inactive", value: t("inactive") },
        { id: "all", value: t("all") },
      ],
    },
    
  ]);

  //to update the page title
  useEffect(() => {
    document.title = `${t("nationalities")} - PersoBase`;
  }, [t]);

  // nationalityTransform.js
const transformNationalityData = (data, t) => {

  const monthLabels = [];
  const nationalityMap = {};
  const totals = new Array(12).fill(0);
  const date = new Date();

  data?.data?.forEach((monthData) => {
    const { month, nationalities } = monthData;
    totals[month - 1] = nationalities.reduce((acc, nat) => acc + nat.count, 0);
  });

  data?.data?.forEach((monthData) => {
    const { month, nationalities } = monthData;
    monthLabels.push(`${t(`month-${month}`)} ${date.getFullYear()}`);

    nationalities.forEach((nat) => {
      const lang = localStorage.getItem("_lang") || "de";
      const natName = nat[lang] || nat.de;
      if (!nationalityMap[natName]) {
        nationalityMap[natName] = new Array(12).fill(0);
      }
      const percentage = totals[month - 1] === 0 ? 0 : (nat.count / totals[month - 1]) * 100;
      nationalityMap[natName][month - 1] = Number(percentage.toFixed(1));
    });
  });

  return {
    series: Object.entries(nationalityMap).map(([key, data]) => ({
      name: key,
      data,
    })),
    categories: monthLabels,
  };
};

  

  // Use the useTranslation hook from react-i18next to handle translations
  // const parkingDuration = totalDuration > 120 ? (days > 0 ? days + `d, ` : ``) + (hours > 0 ? hours + `h, ` : ``) + (minutes + t("m")) : totalDuration.toFixed(0) + ` ` + t("minutes");
  return (
    <Container style={{flexDirection:'column'}} className="noshadow">
      <ListTable bulkUplaod={false} {...props} api={`user`} itemTitle={`fullName`} shortName={`nationalities`} viewDetails={false} addPrivilege={false} delPrivilege={false} updatePrivilege={false} selectPrivilege={false} attributes={attributes} formMode="double" moreOptions={false} popUpUsingId={false} chart={'user/nationalities-count'} datefilter={true} transformData={transformNationalityData}></ListTable>
    </Container>
  );
};
// exporting the page with parent container layout..
export default Layout(Nationalities);
